import i18n from '../../utils/i18n';

export default [
  {
    id: 'video',
    name: i18n.t('frontproductpage.petfood.video_tab.label', {
      defaultValue: 'Video',
    }),
    type: 'specific',
    content: [
      {
        fields: [
          {
            model: 'assets',
            inputKind: {
              kind: 'dict',
            },
            children: [
              {
                model: 'videos',
                inputKind: {
                  kind: 'list',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'tips',
    name: i18n.t('frontproductpage.petfood.tips_tab.label', {
      defaultValue: 'Tips',
    }),
    type: 'specific',
    content: [
      {
        fields: [
          {
            model: 'assets',
            inputKind: {
              kind: 'dict',
            },
            children: [
              {
                model: 'enriched_contents',
                inputKind: {
                  kind: 'list',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'benefits',
    name: i18n.t('frontproductpage.petfood.benefits_tab.label', {
      defaultValue: 'Details',
    }),
    type: 'generic',
    content: [
      {
        title: i18n.t('frontproductpage.petfood.benefits_usage.title', {
          defaultValue: 'Why use this product?',
        }),
        fields: [
          {
            model: 'nutritionalAllegations', // 'allegations',
            label: 'Avantages consommateur',
            inputKind: {
              kind: 'list',
            },
            children: [
              {
                model: 'text',
                inputKind: {
                  kind: 'text',
                },
                declinableBy: {
                  kind: 'languages',
                  model: 'expressedIn',
                  url: '/core/v3/referentials/languages',
                },
              },
            ],
          },
          {
            model: 'consumerBenefits',
            label: 'Avantages consommateur',
            inputKind: {
              kind: 'list',
            },
            children: [
              {
                model: 'text',
                inputKind: {
                  kind: 'text',
                },
                declinableBy: {
                  kind: 'languages',
                  model: 'expressedIn',
                  url: '/core/v3/referentials/languages',
                },
              },
            ],
          },
          {
            model: 'productBenefits',
            label: 'Avantages produit',
            inputKind: {
              kind: 'list',
            },
            children: [
              {
                model: 'text',
                inputKind: {
                  kind: 'text',
                },
                declinableBy: {
                  kind: 'languages',
                  model: 'expressedIn',
                  url: '/core/v3/referentials/languages',
                },
              },
            ],
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.benefits_qualities.title', {
          defaultValue: 'Qualities not to forget!',
        }),
        fields: [
          {
            model: 'advertisedInformations',
            label: 'Allégations marketing',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
    ],
  },
  {
    id: 'composition',
    name: i18n.t('frontproductpage.petfood.composition_tab.label', {
      defaultValue: 'Composition',
    }),
    type: 'generic',
    content: [
      {
        title: i18n.t('frontproductpage.petfood.composition_content.title', {
          defaultValue: "What's in it?",
        }),
        fields: [
          {
            model: 'composition',
            inputKind: {
              kind: 'text',
            },
            options: {
              richContent: true,
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.composition_additives.title', {
          defaultValue: 'Additives',
        }),
        fields: [
          {
            model: 'additives',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.composition_allergens.title', {
          defaultValue: 'Allergens',
        }),
        fields: [
          {
            model: 'allergens',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.composition_flavor.title', {
          defaultValue: 'Taste and aroma',
        }),
        fields: [
          {
            model: 'flavorStatement',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
    ],
  },
  {
    id: 'nutritionpetfood',
    name: i18n.t('frontproductpage.petfood.pet_nutrition_tab.label', {
      defaultValue: 'Analytical constituent',
    }),
    type: 'generic',
    content: [
      {
        fields: [
          {
            model: 'nutritionAdditional',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
          {
            model: 'analyticalConstituents',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
    ],
  },
  {
    id: 'advices',
    name: i18n.t('frontproductpage.petfood.advices_tab.label', {
      defaultValue: 'Advices',
    }),
    type: 'generic',
    content: [
      {
        title: i18n.t('frontproductpage.petfood.advices_usage_tips.title', {
          defaultValue: 'Usage tips',
        }),
        fields: [
          {
            model: 'advices',
            label: 'Mode d’emploi',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
          {
            model: 'pairings',
            label: 'Accords suggérés',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
    ],
  },
  {
    id: 'tasting',
    name: i18n.t('frontproductpage.petfood.tasting_tab.label', {
      defaultValue: 'Tasting',
    }),
    type: 'generic',
    content: [
      {
        fields: [
          {
            model: 'appearanceOlfactory',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
          {
            model: 'appearanceTaste',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
          {
            model: 'appearanceVisual',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
    ],
  },
  {
    id: 'conservation',
    name: i18n.t('frontproductpage.petfood.conservation_tab.label', {
      defaultValue: 'Conservation',
    }),
    type: 'generic',
    content: [
      {
        title: i18n.t('frontproductpage.petfood.conservation_advices.title', {
          defaultValue: 'Conservation advices',
        }),
        fields: [
          {
            model: 'conservations',
            inputKind: {
              kind: 'list',
            },
            children: [
              {
                model: 'text',
                inputKind: {
                  kind: 'text',
                },
                declinableBy: {
                  kind: 'languages',
                  model: 'expressedIn',
                  url: '/core/v3/referentials/languages',
                },
              },
            ],
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.conservation_period.title', {
          defaultValue: 'Period after opening (in months).',
        }),
        fields: [
          {
            model: 'periodAfterOpening',
            inputKind: {
              kind: 'float',
            },
            options: {
              icon: 'IconPao',
              prefix: i18n.t(
                'frontproductpage.petfood.conservation_period_prefix.label',
                { defaultValue: 'Period after opening ' }
              ),
              suffix: i18n.t(
                'frontproductpage.petfood.conservation_period_suffix.label',
                { defaultValue: ' months' }
              ),
            },
          },
        ],
      },
      {
        fields: [
          {
            model: 'peremption',
            inputKind: {
              kind: 'text',
            },
          },
        ],
      },
      {
        title: i18n.t(
          'frontproductpage.petfood.conservation_legal_info.title',
          { defaultValue: 'Warnings and legal information' }
        ),
        fields: [
          {
            model: 'compulsoryStatements',
            inputKind: {
              kind: 'list',
            },
            children: [
              {
                model: 'text',
                inputKind: {
                  kind: 'text',
                },
                declinableBy: {
                  kind: 'languages',
                  model: 'expressedIn',
                  url: '/core/v3/referentials/languages',
                },
              },
            ],
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.conservation_dangers.label', {
          defaultValue: 'Dangers and Warnings',
        }),
        fields: [
          {
            model: 'hazardPictograms',
            inputKind: {
              kind: 'list',
            },
            children: [
              {
                model: 'isConceptualizedBy',
                inputKind: {
                  kind: 'dict',
                },
                options: {
                  pictureUrl: true,
                },
                children: [
                  {
                    model: 'pictureUrl',
                    inputKind: {
                      kind: 'text',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'expertise',
    name: i18n.t('frontproductpage.petfood.expertise_tab.label', {
      defaultValue: 'Expertise',
    }),
    type: 'generic',
    content: [
      {
        title: i18n.t('frontproductpage.petfood.expertise_history.title', {
          defaultValue: 'History',
        }),
        fields: [
          {
            model: 'history',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.expertise_brand.title', {
          defaultValue: 'About the brand',
        }),
        fields: [
          {
            model: 'brandHighlight',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
      {
        title: i18n.t('frontproductpage.petfood.expertise_manufacture.title', {
          defaultValue: 'Manufacture Insights',
        }),
        fields: [
          {
            model: 'manufactureInsights',
            inputKind: {
              kind: 'text',
            },
            declinableBy: {
              kind: 'languages',
              model: 'expressedIn',
              url: '/core/v3/referentials/languages',
            },
          },
        ],
      },
    ],
  },
];
